<div class="card h-full flex flex-col">
  <div class="flex justify-between items-center mb-4">
    <h2 class="text-xl font-semibold">Les causes potentielles</h2>
    <button
      *ind4HasRole="'SED_PLUS_REGULAR_USER'"
      pButton
      pRipple
      icon="pi pi-pencil"
      label="Modifier"
      class="p-button-sm p-button-outlined"
      (click)="openEditModal()"
    ></button>
  </div>
  <app-data-state [loading]="loading$ | async" [error]="error$ | async">
    <div class="p-fluid flex-1 flex flex-col">
      <div class="flex flex-col flex-1 justify-center gap-2">
        <ng-template #noData>
          <app-no-data></app-no-data>
        </ng-template>
        <div
          *ngIf="sortedPotentialCauses?.length; else noData"
          class="cause-list"
        >
          <div
            *ngFor="let cause of sortedPotentialCauses"
            class="cause-item"
            [ngClass]="getColorClass(cause.percentage)"
          >
            <div class="cause-left">
              <lucide-icon
                [ngClass]="getBarIconColorClass(cause.percentage)"
                [size]="20"
                name="triangle-alert"
              ></lucide-icon>
              <div class="cause-label">
                {{ cause?.description }}
              </div>
            </div>
            <div
              class="cause-percentage"
              [ngClass]="getBarColorClass(cause.percentage)"
            >
              {{ cause?.percentage }}%
            </div>
            <div class="cause-bar" [ngClass]="getColorClass(cause.percentage)">
              <div
                class="bar-fill"
                [ngClass]="getBarFillClass(cause.percentage)"
                [ngStyle]="{ width: cause.percentage + '%' }"
              ></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </app-data-state>

  <!-- Edit Modal -->
  <app-edit-potential-causes-modal
    [visible]="showEditModal"
    [items]="potentialCause ?? []"
    [ruleUid]="ruleUid ?? ''"
    (visibleChange)="showEditModal = $event"
    (onSubmitForm)="onModalSubmit($event)"
    (onCancelForm)="onModalCancel()"
  ></app-edit-potential-causes-modal>
</div>
